export const breakpointNames = {
  DESKTOP: 'desktop',
  SCALE: 'scale',
  TABLET: 'tablet',
  MOBILE: 'mobile',
  XMOBILE: 'xmobile',
}

export const viewNames = { COMPACT: 'mobile', FULL: 'desktop' }

export const views = {
  [viewNames.COMPACT]: [breakpointNames.MOBILE, breakpointNames.XMOBILE, breakpointNames.TABLET],
  [viewNames.FULL]: [breakpointNames.SCALE, breakpointNames.DESKTOP]
}

export function getBreakpointView (breakpoint) {
  return Object.keys(views).find((key) => (views[key].indexOf(breakpoint) > -1))
}

export default {
  [breakpointNames.DESKTOP]: [1366, 99999],
  [breakpointNames.SCALE]: [1024, 1365],
  [breakpointNames.TABLET]: [768, 1024],
  [breakpointNames.MOBILE]: [0, 767],
  [breakpointNames.XMOBILE]: [0, 374]
}

